import { render, staticRenderFns } from "./ProducingList.vue?vue&type=template&id=3b118324&"
import script from "./ProducingList.ts?vue&type=script&lang=js&"
export * from "./ProducingList.ts?vue&type=script&lang=js&"
import style0 from "./ProducingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports